import React from "react";
import { Icon } from "@/components/Icon";

export interface StatCardProps {
    title: string;
    value: string | number;
    icon?:
        | React.ComponentType<{ size?: number; className?: string }>
        | React.ReactNode
        | string;
    iconPosition?: string;
    colorClass?: string;
    valueColorClass?: string;
    className?: string;
    titleClassName?: string;
    onClick?: () => void;
}

export const StatCard: React.FC<StatCardProps> = ({
    title,
    value,
    icon,
    iconPosition = "top",
    colorClass = "bg-slate-100 text-slate-700",
    valueColorClass = "text-slate-900 dark:text-white",
    className = "",
    titleClassName = "",
    onClick,
}) => {
    const renderIconContent = () => {
        if (!icon) {
            return null;
        }

        if (typeof icon === "string") {
            return <Icon value={icon} size={25} />;
        }

        if (React.isValidElement(icon)) {
            return icon;
        }

        const IconComp = icon as React.ComponentType<{
            size?: number;
            className?: string;
        }>;
        return <IconComp size={25} />;
    };

    return (
        <div
            onClick={onClick}
            className={`bg-box rounded-2xl border border-box p-4 shadow-xs flex flex-col items-center justify-center text-center transition-all hover:shadow-md ${onClick ? "cursor-pointer hover:-translate-y-0.5" : ""} ${className}`}
        >
            {/* Top row: Icon on top if iconPosition === 'top' */}
            {icon && (!iconPosition || iconPosition === "top") && (
                <div className="mb-2">
                    <div className={`${colorClass}`}>{renderIconContent()}</div>
                </div>
            )}
            <div className="flex items-center justify-center gap-2">
                {icon && iconPosition === "left" && (
                    <div className={`${colorClass}`}>{renderIconContent()}</div>
                )}
                <span
                    className={`text-[11px] sm:text-xs font-bold text-slate-500 dark:text-zinc-400 leading-tight ${titleClassName}`}
                >
                    {title}
                </span>
            </div>

            {/* Bottom row: Value centered */}
            <div
                className={`text-2xl sm:text-3xl font-black tracking-tight mt-2.5 text-center ${valueColorClass}`}
            >
                {value}
            </div>
        </div>
    );
};

export default StatCard;
